export { default } from './skeleton-builder.component';
